import {
  ReadUserGuideRequest,
  UserGuideServiceClient,
} from '../proto/admpb/userguide_grpc_web_pb';
import { auth } from '../lib/auth/Auth';

const service = new UserGuideServiceClient(window.env.GRPC_ENDPOINT, {}, { ...auth });

export async function readUserGuide(id) {
  return new Promise((resolve, reject) => {
    const req = new ReadUserGuideRequest();
    req.setPageId(id);

    service.readUserGuide(req, {}, (error, response) => {
      if (error) {
        resolve({ userGuide: { userGuideId: 0 } });
      } else {
        resolve(response.toObject());
      }
    });
  });
}
